import sharedCardCarousel from './shared-card-carousel';

export default function eventsNewsCarousel(root: HTMLElement): void {
  sharedCardCarousel(root, { duration: 35 });
}
